jQuery(function () {
  // handles the changing of tabs
  window.onpopstate = function (event) {
    window.location.reload(true)
  }

  // when clicking on the tabs we add a
  // a new entry to the browser history
  $('.offices-tabs--links')
    .children('a')
    .on('click', function () {
      const tab = $(this)
      const urlParams = getAllParamsFromUrl()
      const data = tab.data('tab')
      let url = `${window.location.pathname}`
      const params = []

      data !== 'main-office' && params.push(`tab=${data}`)

      urlParams.offices_location &&
        params.push(`offices_location=${urlParams.offices_location}`)

      urlParams.office_service &&
        params.push(`office_service=${urlParams.office_service}`)

      if (params.length) {
        url += `?${params.join('&')}`
      }

      window.history.pushState({ tab: data }, '', url)
    })

  // Click event that changes the name of the service
  // on the url and reload the page for DESKTOP
  $('.filter.all-offices a').on('click', function (event) {
    event.preventDefault()
    const anchor = $(this)
    const location = anchor.prop('title')

    const urlParams = getAllParamsFromUrl()
    urlParams.office_service = location
    handleParametersOnURL(urlParams)
    window.location.reload(true)
  })

  // Change value of the selected service area
  $('.dropdown__wrapper.all-offices li').on('click', function () {
    const item = $(this)
    const val = item.attr('rel')
    $('.dropdown__wrapper.all-offices')
      .find('.styledSelect')
      .attr('value', val)
  })

  // Update service area filter on mobile mode
  $('.optionsBtn.all-offices').on('click', function () {
    const selected = $('.dropdown__wrapper.all-offices').find('.styledSelect')
    const serviceArea = selected.attr('value')
    const urlParams = getAllParamsFromUrl()

    urlParams.office_service = serviceArea
    handleParametersOnURL(urlParams)
    window.location.reload(true)
  })

  // When clicking the button to open the service area filters
  // we guarantee that the select filter is the one on the URL
  $('.filterBtn.all-offices').on('click', function () {
    const mobileAllOffices = $('.dropdown__wrapper.all-offices')
    const urlParams = getAllParamsFromUrl()
    const serviceArea = urlParams.office_service
    const listItem = mobileAllOffices.find(`li[rel=${serviceArea}]`)

    if (listItem.length) {
      listItem.trigger('click')
    } else {
      mobileAllOffices.find('li').first().trigger('click')
    }
  })
})

function getAllParamsFromUrl () {
  var query = location.search.substr(1)
  var params = query.split('&')
  var result = {}
  for (var i = 0; i < params.length; i++) {
    var item = params[i].split('=')

    const key = item[0].replace(/\[|\]/g, '')
    const value = item[1]

    if (!result[key]) result[key] = [value]
    else result[key].push(value)
  }
  return result
}

function handleParametersOnURL (params) {
  let urlWithParams = location.origin + location.pathname

  if (params) {
    const parametersOnURL = Object.keys(params)
      .filter((parameterName) => params[parameterName])
      .filter((parameterName) =>
        Array.isArray(params[parameterName])
          ? params[parameterName].length > 0
          : true
      )
      .map(
        (parameterName) =>
          `${$.param({ [parameterName]: params[parameterName] }, true)}`
      )
      .join('&')

    if (parametersOnURL) {
      urlWithParams += decodeURI(`?${parametersOnURL}`)
    }
  }

  history.pushState(undefined, undefined, urlWithParams)
}
